export class PickupRequest {
  ModuleName: string;
  Description: string;
  Location: string;
  DateTime: Date;
  CostsToBePaid: number;
  Remarks: string;
}
